/**
 * Who the viewer may start a chat with (release fixes, 28 Sep 2026).
 *
 * A SEPARATE QUESTION from `obfuscated`, which follows the club's "Hide member
 * contact details" setting (on by default) and only hides email and phone. The
 * Message button used to read `!obfuscated`, so club-mates looked
 * unmessageable. The API now answers `canMessage` per viewer on every player
 * and user row (any member of a club you are in, a junior only for an admin of
 * their club, never yourself). An older API sends none, so fall back to the old
 * rule there.
 *
 * Pure, imported explicitly. Mirrors the app's message_permission.dart.
 */

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const HIDDEN_CONTACTS_NOTE = 'This club hides player contact details.';

export function canMessagePerson(person, {signedIn, myUserId} = {}) {
    if (!signedIn || !person) return false;
    const to = person.userId;
    if (typeof to !== 'string' || !GUID.test(to)) return false;
    if (myUserId && to.toLowerCase() === String(myUserId).toLowerCase()) return false;
    return person.canMessage ?? !person.obfuscated;
}

/**
 * The button a member card offers (29 Sep 2026): 'message', 'unblock' or null.
 *
 * Someone the VIEWER blocked is offered "Unblock to message" rather than a
 * Message button that the server would only refuse (the API's canMessage is
 * false for them). Someone who blocked the viewer is not in this list, so they
 * keep the ordinary button and a send is refused with wording that names
 * nobody: a block is never announced to the person blocked.
 *
 * Mirrors the app's messageActionFor in message_permission.dart.
 */
export const UNBLOCK_TO_MESSAGE_LABEL = 'Unblock to message';

export function messageActionFor(person, {signedIn, myUserId, blockedUserIds = []} = {}) {
    if (!signedIn || !person) return null;
    const to = person.userId;
    if (typeof to !== 'string' || !GUID.test(to)) return null;
    if (myUserId && to.toLowerCase() === String(myUserId).toLowerCase()) return null;
    const blocked = (blockedUserIds || []).some(id => String(id).toLowerCase() === to.toLowerCase());
    if (blocked) return 'unblock';
    return canMessagePerson(person, {signedIn, myUserId}) ? 'message' : null;
}
